export default __webpack_public_path__ + "static/media/photo--lg--kara11.13942b6e.jpg";